








import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

import CardComponent from '@/modules/core/components/CardComponent.vue';
import { SocketIOService } from '@/socketio.service';

@Component({
  components: {
    CardComponent,
  },
})
export default class DeviceConnectionIndicator extends Vue {
  @Prop({
    default: null,
  })
  public device: any;

  public deviceConnectedListener = (deviceId: string): void => {
    if (deviceId === this.device.id) {
      this.device.socketConnected = true;
    }
  }

  public deviceDisconnectedListener = (deviceId: string): void => {
    if (deviceId === this.device.id) {
      this.device.socketConnected = false;
    }
  }

  public get title(): string {
    if (!this.device) {
      return 'Non connnecté';
    }

    return this.device.socketConnected ? 'Connecté' : 'Non connecté';
  }

  public mounted(): void {
    SocketIOService.sockets.backend.emit(
      'isDeviceConnected',
      this.device.id,
      (connected: boolean) => {
        this.device.socketConnected = connected;
      },
    );

    SocketIOService.sockets.backend.on(
      'deviceConnected',
      this.deviceConnectedListener,
    );
    SocketIOService.sockets.backend.on(
      'deviceDisconnected',
      this.deviceDisconnectedListener,
    );
  }

  public beforeDestroy(): void {
    SocketIOService.sockets.backend.off('deviceConnected', this.deviceConnectedListener);
    SocketIOService.sockets.backend.off('deviceDisconnected', this.deviceDisconnectedListener);
  }
}
